import React from 'react';
import { Outlet } from 'react-router-dom';

import { AppSideNav } from '@app/components/AppSideNav';
import { AppTopBar } from '@app/components/AppTopBar';
import { DocumentTitleUpdater } from '@app/components/DocumentTitleUpdater';

/**
 * Main layout wrapper for the application.
 */
export const AppLayout: React.FC = () => {
	const [isSideNavOpen, setIsSideNavOpen] = React.useState(true);

	return (
		<div className='app-layout'>
			<DocumentTitleUpdater />
			<AppTopBar onToggleSideNav={() => setIsSideNavOpen((prev) => !prev)} />
			<div className='app-body'>
				<AppSideNav isOpen={isSideNavOpen} />
				<main className='app-layout-content'>
					<Outlet />
				</main>
			</div>
		</div>
	);
};
